<template>
<div class="card card-custom gutter-b card-stretch ">
    <div class="card-header">
        <h1 class="card-title font-size-h3 font-weight-bolder">
            Participar en eventos
        </h1>
    </div>

    <div class="card-body">

        <div class="card-columns">

            <div class="card card-hover" v-for="(evento, index) in filterEvents" :key="index">
                <router-link :to="'/participate/' + evento.slug" tag="a">
                    <div class="card-img-top h-150px" :style="'background:url(' + evento.logo + ') center center / cover no-repeat fixed;'"></div>
                    <!--<img class="card-img-top" src="''" alt="Card image cap">-->
                    <div class="card-body">
                        <h5 class="card-title font-weight-bolder text-center" v-text="evento.name"></h5>
                        <ul class="card-text list-unstyled">
                            <li v-if="evento.location!=null"><i class="fas fa-map-marker-alt mr-3"></i>{{evento.location}}</li>
                            <li><i class="far fa-calendar-alt mr-3"></i>{{$moment(evento.startdate).format('DD MMM')}}
                                <span v-if="evento.startdate != evento.enddate"> - {{$moment(evento.enddate).format('DD MMM YYYY')}}</span>
                            </li>
                            <li><i class="far fa-user mr-3"></i>154 registrados</li>
                            <li v-if="evento.deadline !=null"><i class="far fa-clock mr-3"></i>Inscripciones hasta {{$moment(evento.deadline).format('DD MMM hh:mm A')}}</li>

                        </ul>
                        <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                        <div class="btn btn-sm btn-block" :class="[evento.register=='1' ? 'btn-outline-success' : 'btn-outline-danger']">Inscripciones {{evento.register == '1' ? 'abiertas' : 'cerradas'}}</div>
                    </div>
                </router-link>
            </div>

        </div>

    </div>
</div>
</template>

<script>
//import services
import pservice from "@/core/services/pbapi.service"

import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

export default {
    name: "Details",
    data: () => ({
        search: '',
        listEvents: []
    }),
    computed: {
        filterEvents: function() {
            this.tableEvents = this.listEvents;
            return this.tableEvents.filter(data => !this.search || data.name.toLowerCase().includes(this.search.toLowerCase()))
        },
    },
    methods: {
        async getData() {
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await pservice.getEvents().then((res) => {
                this.listEvents = res.data
                //console.log(res.data)
            }).catch((err) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        }
    },
    created() {
        this.getData()
    }
}
</script>
